import { k, t } from '../../localization/t';
import { api } from '../serverClient';

// Alchemist section of class-design.excalidraw, authored by Fabian.
// Effect magnitudes and ingredient costs are not specified in the source.
export const ALCHEMIST_POTIONS = [
  { key: 'lucidity', title: k('Lucidity'), effect: k('+100% Arcana earned from matches.'),
    dropTitle: k('A Moment of Clarity'), recipeTitle: k('The Quiet Between Thoughts'),
    dropDesc: k('Unlocks Potion of Lucidity drops.'),
    recipeDesc: k('Unlocks Potion of Lucidity recipe.'),
    flavour: k('The world has stopped speaking. At last, you can hear it think.') },
  { key: 'curiosity', title: k('Curiosity'), effect: k('+50% player XP and season XP earned from matches.'),
    dropTitle: k('The Question Remains'), recipeTitle: k('Anatomy of an Answer'),
    dropDesc: k('Unlocks Potion of Curiosity drops.'),
    recipeDesc: k('Unlocks Potion of Curiosity recipe.'),
    flavour: k('Every answer is an invitation to a worse question.') },
  { key: 'fixation', title: k('Fixation'), effect: k('+20% humours from defeated enemy minions.'),
    dropTitle: k('Nothing Goes to Waste'), recipeTitle: k('The Work of Obsession'),
    dropDesc: k('Unlocks Potion of Fixation drops.'),
    recipeDesc: k('Unlocks Potion of Fixation recipe.'),
    flavour: k('There is still something to be learned from the remains.') },
  { key: 'avarice', title: k('Avarice'), effect: k('+50% gold earned from matches.'),
    dropTitle: k('The Shape of Want'), recipeTitle: k('A Reason to Have More'),
    dropDesc: k('Unlocks Potion of Avarice drops.'),
    recipeDesc: k('Unlocks Potion of Avarice recipe.'),
    flavour: k('Enough is a word invented by people who stopped.') },
  { key: 'epiphany', title: k('Epiphany'), effect: k('50% chance to upgrade 1 card to Unique. Highest rarity first; preserves existing Uniques and foils.'),
    dropTitle: k('Suddenly, It Makes Sense'), recipeTitle: k('The World Behind the World'),
    dropDesc: k('Unlocks Potion of Epiphany drops.'),
    recipeDesc: k('Unlocks Potion of Epiphany recipe.'),
    flavour: k('Of course it was there. It has always been there.') },
  { key: 'euphoria', title: k('Euphoria'), effect: k('50% chance to turn 1 additional card into a foil in each booster. Keeps its rarity.'),
    dropTitle: k('You Deserve This'), recipeTitle: k('The Art of Self-Deception'),
    dropDesc: k('Unlocks Potion of Euphoria drops.'),
    recipeDesc: k('Unlocks Potion of Euphoria recipe.'),
    flavour: k('You were meant for finer things. Here is the evidence.') },
  { key: 'yearning', title: k('Yearning'), effect: k('Adds 1 Elite card per booster, with its own 20% chance to become Unique and the normal chance to be foil.'),
    dropTitle: k('Something Is Missing'), recipeTitle: k('A Place for Desire'),
    dropDesc: k('Unlocks Potion of Yearning drops.'),
    recipeDesc: k('Unlocks Potion of Yearning recipe.'),
    flavour: k('Something is missing. One more might be enough.') },
  { key: 'rumination', title: k('Rumination'), effect: k('Cards you already own a playset of become cards you do not, at the same rarity.'),
    dropTitle: k('What Might Have Been'), recipeTitle: k('A More Convenient Past'),
    dropDesc: k('Unlocks Potion of Rumination drops.'),
    recipeDesc: k('Unlocks Potion of Rumination recipe.'),
    flavour: k('You have accepted what happened. You would simply prefer that it hadn’t.') },
];

export const ALCHEMIST_POTENCY = [
  { perks: 5, title: k('Exceptional Potions'), power: 2, uses: 1, discount: 10 },
  { perks: 10, title: k('Elite Potions'), power: 3, uses: 1, discount: 20 },
  { perks: 15, title: k('Unique Potions'), power: 4, uses: 1, discount: 30 },
];

// Each pair belongs to a humour quadrant, not to potion drop odds or
// potion strength. Each perk grants a 15% yield increase. The first of
// each pair sits on the line from its recipe to the neighbouring drop and
// can be reached from either end of that line or from its own drop.
export const ALCHEMIST_YIELD_NODES = [
  { key: 'alchemist_pituita_1', title: k('A Necessary Distance'), type: 'gameplay', x: 245, y: 235,
    requires: ['alchemist_lucidity_drop', 'alchemist_lucidity_recipe', 'alchemist_rumination_drop'], humour: 'pituita', yieldBonus: 0.15,
    desc: k('Collect 15% more Pituita from defeated enemy minions.') },
  { key: 'alchemist_pituita_2', title: k('The Mercy of Feeling Nothing'), type: 'gameplay', x: 190, y: 95,
    requires: ['alchemist_lucidity_recipe'], humour: 'pituita', yieldBonus: 0.15,
    desc: k('Collect 15% more Pituita from defeated enemy minions.') },
  { key: 'alchemist_sanguis_1', title: k('The Heart Insists'), type: 'gameplay', x: 755, y: 235,
    requires: ['alchemist_curiosity_drop', 'alchemist_curiosity_recipe', 'alchemist_euphoria_drop'], humour: 'sanguis', yieldBonus: 0.15,
    desc: k('Collect 15% more Sanguis from defeated enemy minions.') },
  { key: 'alchemist_sanguis_2', title: k('An Argument for Living'), type: 'gameplay', x: 810, y: 120,
    requires: ['alchemist_curiosity_recipe'], humour: 'sanguis', yieldBonus: 0.15,
    desc: k('Collect 15% more Sanguis from defeated enemy minions.') },
  { key: 'alchemist_melancholia_1', title: k('The Weight of Memory'), type: 'gameplay', x: 245, y: 402.5,
    requires: ['alchemist_fixation_drop', 'alchemist_fixation_recipe', 'alchemist_rumination_drop'], humour: 'melancholia', yieldBonus: 0.15,
    desc: k('Collect 15% more Melancholia from defeated enemy minions.') },
  { key: 'alchemist_melancholia_2', title: k('Grief Has Its Uses'), type: 'gameplay', x: 190, y: 550,
    requires: ['alchemist_fixation_recipe'], humour: 'melancholia', yieldBonus: 0.15,
    desc: k('Collect 15% more Melancholia from defeated enemy minions.') },
  { key: 'alchemist_cholera_1', title: k('A Well-Kept Grudge'), type: 'gameplay', x: 755, y: 402.5,
    requires: ['alchemist_avarice_drop', 'alchemist_avarice_recipe', 'alchemist_euphoria_drop'], humour: 'cholera', yieldBonus: 0.15,
    desc: k('Collect 15% more Cholera from defeated enemy minions.') },
  { key: 'alchemist_cholera_2', title: k('The Discipline of Anger'), type: 'gameplay', x: 810, y: 550,
    requires: ['alchemist_avarice_recipe'], humour: 'cholera', yieldBonus: 0.15,
    desc: k('Collect 15% more Cholera from defeated enemy minions.') },
];

// Preserve the four quadrants and the eight outward Drop → Recipe paths.
const BRANCHES = [
  ['lucidity', [360, 230], [300, 150], ['alchemist_foundation']],
  ['curiosity', [640, 230], [700, 150], ['alchemist_foundation']],
  ['fixation', [360, 420], [300, 485], ['alchemist_foundation']],
  ['avarice', [640, 420], [700, 485], ['alchemist_foundation']],
  ['epiphany', [500, 150], [500, 50], ['alchemist_lucidity_recipe', 'alchemist_curiosity_recipe']],
  ['euphoria', [810, 320], [930, 320], ['alchemist_curiosity_recipe', 'alchemist_avarice_recipe']],
  ['yearning', [500, 470], [500, 565], ['alchemist_fixation_recipe', 'alchemist_avarice_recipe']],
  ['rumination', [190, 320], [70, 320], ['alchemist_lucidity_recipe', 'alchemist_fixation_recipe']],
];

export const ALCHEMIST_NODES = [
  { key: 'alchemist_foundation', title: k('The Divided Self'), type: 'hub', major: true, x: 500, y: 320,
    desc: k('Opens the Alembic for potion crafting. Collect Pituita, Sanguis, Melancholia and Cholera from defeated enemy minions according to their element. Learn potion drops and recipes along the four branches.') },
  ...BRANCHES.flatMap(([key, drop, recipe, requires]) => {
    const potion = ALCHEMIST_POTIONS.find((entry) => entry.key === key);
    return [
      { key: `alchemist_${key}_drop`, title: potion.dropTitle, desc: potion.dropDesc, effect: potion.effect, flavour: potion.flavour,
        type: 'rewards', requires, x: drop[0], y: drop[1], potion: key, unlock: 'drop' },
      { key: `alchemist_${key}_recipe`, title: potion.recipeTitle, desc: potion.recipeDesc, effect: potion.effect, flavour: potion.flavour,
        type: 'hub', requires: [`alchemist_${key}_drop`], x: recipe[0], y: recipe[1], potion: key, unlock: 'recipe' },
    ];
  }),
  ...ALCHEMIST_YIELD_NODES,
];

// Milestones do not spend additional points. Count only distinct Alchemist
// perks so foreign or repeated keys cannot inflate the displayed tier.
export function alchemistPerksSpent(state) {
  if (state?.classKey !== 'alchemist') return 0;
  const valid = new Set(ALCHEMIST_NODES.map((node) => node.key));
  return new Set((state.pointsSpent || []).filter((key) => valid.has(key))).size;
}

// ── Runtime: humours, recipes, the laboratory ─────────────────────────
// Rules and every number live on the server in
// valkenhall-server/src/utils/alchemist.js; this half names the humours,
// mirrors the recipes for display and calls the routes. Keep in lockstep.

export const HUMOURS = [
  { key: 'pituita', label: k('Pituita'), element: 'Water', color: '#7fb8d8', note: k('Phlegm. Calm, patience, the slow thought.') },
  { key: 'sanguis', label: k('Sanguis'), element: 'Air', color: '#d86a6a', note: k('Blood. Warmth, appetite, the quick heart.') },
  { key: 'melancholia', label: k('Melancholia'), element: 'Earth', color: '#8a7cb8', note: k('Black bile. Memory, grief, the long look back.') },
  { key: 'cholera', label: k('Cholera'), element: 'Fire', color: '#e0a04a', note: k('Yellow bile. Anger, ambition, the will to have.') },
];
export const HUMOUR_SCALE = 10; // Server match counters use rarity weights of 1/2/3/4.
export const HUMOUR_BY_KEY = Object.fromEntries(HUMOURS.map((h) => [h.key, h]));

// kind: 'match' potions settle with the match reward, 'pack' potions act
// when a booster is opened. cost: humours per brew.
export const POTION_RECIPES = {
  lucidity:   { kind: 'match', cost: { pituita: 120 } },
  curiosity:  { kind: 'match', cost: { sanguis: 120 } },
  fixation:   { kind: 'match', cost: { melancholia: 120 } },
  avarice:    { kind: 'match', cost: { cholera: 120 } },
  epiphany:   { kind: 'pack', cost: { pituita: 100, sanguis: 100 } },
  euphoria:   { kind: 'pack', cost: { sanguis: 100, cholera: 100 } },
  yearning:   { kind: 'pack', cost: { melancholia: 100, cholera: 100 } },
  rumination: { kind: 'pack', cost: { pituita: 100, melancholia: 100 } },
};

// Fixed bottle variants. The tree unlocks brewing, never upgrades owned bottles.
export const POTION_POTENCIES = [
  { key: 'ordinary', title: k('Ordinary'), perks: 0, power: 1, uses: 1, discount: 0 },
  { key: 'exceptional', title: k('Exceptional'), perks: 5, power: 2, uses: 1, discount: 10 },
  { key: 'elite', title: k('Elite'), perks: 10, power: 3, uses: 1, discount: 20 },
  { key: 'unique', title: k('Unique'), perks: 15, power: 4, uses: 1, discount: 30 },
];
export const potionPotency = (key) => POTION_POTENCIES.find((tier) => tier.key === key);
export const canBrewPotency = (skills, potency) => {
  const tier = potionPotency(potency);
  return Boolean(tier && isAlchemist(skills) && alchemistPerksSpent(skills) >= tier.perks);
};
export function potionCost(key, potency = 'ordinary') {
  const tier = potionPotency(potency);
  if (!tier || !Object.hasOwn(POTION_RECIPES, key)) return null;
  return Object.fromEntries(Object.entries(POTION_RECIPES[key].cost)
    .map(([humour, n]) => [humour, Math.floor(n * tier.power * (100 - tier.discount) / 100)]));
}

// Rugged medieval crayon plates, with the colored pigment backdrop baked
// into each image. Sources and prompts live in assets/mastery/potions;
// build-web copies public/mastery so local previews need no CDN upload.
const PLATES = '/mastery/potions/medieval-v2';
export const potionArt = (key) => `${PLATES}/${key}.webp`;
export const potionArtMask = (key) => `url("/mastery/potions/organic-masks/${key}.svg")`;

export const isAlchemist = (state) => state?.classKey === 'alchemist';
const has = (state, key) => Boolean(state?.pointsSpent?.includes(key));
export const canDrop = (state, key) => isAlchemist(state) && has(state, `alchemist_${key}_drop`);
export const canBrew = (state, key) => isAlchemist(state) && has(state, `alchemist_${key}_recipe`);

// Highest unlocked brewing strength; not the duration of an owned bottle.
export function potencyPower(state) {
  const spent = alchemistPerksSpent(state);
  let power = 1;
  for (const tier of ALCHEMIST_POTENCY) if (spent >= tier.perks) power = tier.power;
  return power;
}

export const isActive = (alchemist, key) => (alchemist?.active?.[key]?.uses || 0) > 0;
export function potionStock(alchemist, key, potency = 'ordinary') {
  if (!potionPotency(potency)) return 0;
  const stock = alchemist?.potions?.[key];
  const n = typeof stock === 'number' ? (potency === 'ordinary' ? stock : 0) : stock?.[potency];
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
}

// Server calls. Each answers the inventory and fixed active effects.
export const brewPotion = (potion, potency = 'ordinary') => api.post('/profile/me/alchemist/brew', { potion, potency });
export const drinkPotion = (potion, potency = 'ordinary') => api.post('/profile/me/alchemist/drink', { potion, potency });

// The laboratory and active indicators use the same tier-specific benefit copy.
export function potionEffect(key, potency = 'ordinary') {
  const power = potionPotency(potency)?.power || 1;
  switch (key) {
    case 'lucidity': return t('+{n}% Arcana earned from the next match.', { n: 100 * power });
    case 'avarice': return t('+{n}% gold earned from the next match.', { n: 50 * power });
    case 'curiosity': return t('+{n}% player XP and season XP earned from the next match.', { n: 50 * power });
    case 'fixation': return t('+{n}% humours from defeated enemy minions in the next match.', { n: 20 * power });
    case 'epiphany': {
      const benefit = [
        t('50% chance to upgrade 1 card to Unique.'),
        t('Upgrades 1 card to Unique.'),
        t('Upgrades 1 card to Unique, with a 50% chance for a second.'),
        t('Upgrades 2 cards to Unique.'),
      ][power - 1];
      return `${benefit} ${t('Highest rarity first; preserves existing Uniques and foils.')}`;
    }
    case 'euphoria': return [
      t('50% chance to turn 1 additional card into a foil. Keeps its rarity.'),
      t('Turns 1 additional card into a foil. Keeps its rarity.'),
      t('Turns 1 additional card into a foil, with a 50% chance for a second. Keeps their rarity.'),
      t('Turns 2 additional cards into foils. Keeps their rarity.'),
    ][power - 1];
    case 'yearning': return power === 1
      ? t('Adds 1 Elite card to the next booster, with its own 20% chance to become Unique and the normal chance to be foil.')
      : t('Adds {n} Elite cards to the next booster. Each has its own 20% chance to become Unique and the normal chance to be foil.', { n: power });
    case 'rumination': return power === 1
      ? t('1 card you already own a playset of becomes a card you do not, at the same rarity.')
      : t('Up to {n} cards you already own a playset of become cards you do not, at the same rarity.', { n: power });
    default: return '';
  }
}

export function potionOutcome(key, detail) {
  if (!detail) return t(ALCHEMIST_POTIONS.find(p => p.key === key)?.title || key);
  const name = t('{potency} {name}', { potency: t(potionPotency(detail.potency)?.title || 'Ordinary'), name: t(ALCHEMIST_POTIONS.find(p => p.key === key)?.title || key) });
  const outcome = key === 'epiphany' ? t('{n} Unique upgrades', { n: detail.count })
    : key === 'euphoria' ? t('{n} foil upgrades', { n: detail.count })
      : key === 'yearning' ? t('{n} extra cards', { n: detail.count })
        : t('{n} cards turned', { n: detail.count });
  return `${name} · ${outcome}`;
}
